/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from "prop-types";
/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';
import { AppIcons } from '../../../../data/appIcons';
/** Common Services & Data Files */
import FormCreator from '../../../../components/finalForms/FormCreator';
import ToastService from "../../../../services/toastService/ToastService";
import { ProjectEnvironmentFormData } from './config/ProjectEnvironment.data';
/** RTK Query */
import {
  useAddProjectEnvironmentMutation,
  useLazyGetProjectEnvironmentByEnvironmentIdQuery,
  useUpdateProjectEnvironmentMutation
} from '../../../../app/services/projectenvironmentAPI';

const AddProjectEnvironment = (props) => {
  const ref = useRef();
  /* State*/
  const [formData, setFormData] = useState(ProjectEnvironmentFormData);
  // API'S Call
  const [AddProjectEnvironment, {
    isSuccess: isProjectEnvironmentAdded,
    isLoading: isProjectEnvironmentAdding,
    data: addProjectEnvironmentData
  },] = useAddProjectEnvironmentMutation();

  const [getProjectEnvironmentByEnvironmentId, {
    isFetching: isGetByIdFetching,
    isSuccess: isGetByIdSuccess,
    data: isGetByIdData
  },] = useLazyGetProjectEnvironmentByEnvironmentIdQuery();

  const [UpdateProjectEnvironment, {
    isLoading: isProjectEnvironmentUpdating,
    isSuccess: isProjectEnvironmentUpdateSuccess,
    data: isProjectEnvironmentUpdateData
  },] = useUpdateProjectEnvironmentMutation();

  //** useEffect's */
  useEffect(() => {
    formReset();
    if (props.projectEnvironmentId) {
      getProjectEnvironmentByEnvironmentId(props.projectEnvironmentId);
    }
  }, [props.projectEnvironmentId]);

  useEffect(() => {
    if (isGetByIdSuccess && !isGetByIdFetching && isGetByIdData) {
      if (isGetByIdData) {
        let updatedForm = { ...formData };
        updatedForm.initialState = {
          ...updatedForm.initialState,
          environmentName: isGetByIdData.environmentName,
        };
        setFormData(updatedForm);
      }

    }
  }, [isGetByIdSuccess, isGetByIdFetching, isGetByIdData]);

  useEffect(() => {
    if (isProjectEnvironmentAdded && addProjectEnvironmentData) {
      if (addProjectEnvironmentData.errorMessage?.includes("exists")) {
        ToastService.warning(addProjectEnvironmentData.errorMessage);
      } else {
        ToastService.success(addProjectEnvironmentData.errorMessage);
        backToList();
      }
    }
  }, [isProjectEnvironmentAdded, addProjectEnvironmentData]);


  useEffect(() => {
    if (isProjectEnvironmentUpdateSuccess && isProjectEnvironmentUpdateData) {
      if (isProjectEnvironmentUpdateData.errorMessage?.includes("exists")) {
        ToastService.warning(isProjectEnvironmentUpdateData.errorMessage);
      } else {
        ToastService.success(isProjectEnvironmentUpdateData.errorMessage);
        backToList();
      }
    }
  }, [isProjectEnvironmentUpdateSuccess, isProjectEnvironmentUpdateData]);

  //** Funcation's */
  const formReset = () => {
    const projectForm = { ...ProjectEnvironmentFormData };
    projectForm.initialState = { ...ProjectEnvironmentFormData.initialState };
    setFormData(projectForm);
  }

  const handleSubmit = () => {
    let ProjectTypeManagementData = ref.current.getFormData();
    if (!props.projectEnvironmentId && ProjectTypeManagementData) {
      const requestData = {
        ...ProjectTypeManagementData,
        projectId: props.projectId,
        environmentName: ProjectTypeManagementData.environmentName,
      };
      AddProjectEnvironment(requestData);
    }
    else if (props.projectEnvironmentId && ProjectTypeManagementData) {
      const requestUpdateData = {
        projectId: props.projectId,
        environmentId: props.projectEnvironmentId,
        environmentName: ProjectTypeManagementData.environmentName,
      };
      UpdateProjectEnvironment(requestUpdateData);
    }
  }

  const backToList = () => {
    props.onSidebarClose();
    formReset();
  };

  return (
    <>
      <FormCreator
        config={formData}
        ref={ref}
        {...formData}
      />
      <div className="form-btn d-flex justify-content-end button-align-45 mt-3">
        <Buttons
          buttonTypeClassName="dark-btn"
          onClick={backToList}
          buttonText="Cancel"
        />
        <Buttons
          buttonTypeClassName="theme-btn ml-4"
          onClick={handleSubmit}
          buttonText={`${props.projectEnvironmentId ? "Update" : "Add"}`}
          imagePath={AppIcons.AddIcon}
          isLoading={isProjectEnvironmentAdding || isProjectEnvironmentUpdating}
        />
      </div>
    </>
  );
}

AddProjectEnvironment.propTypes = {
  projectEnvironmentId: PropTypes.number,
  onClose: PropTypes.func,
};
export default AddProjectEnvironment;